module.exports = __webpack_public_path__ + "img/bg-h04.3764a465.jpg";